export default __webpack_public_path__ + "static/media/connectedHome_participation_agreement.0f30c868.pdf";